import {
    AbsoluteCenter,
    Button as ChakraButton,
    ButtonProps as ChakraButtonProps,
    Span,
    Spinner,
} from '@chakra-ui/react';
import React from 'react';

export type ButtonProps = {
    loading?: boolean,
} & ChakraButtonProps

export const Button: React.FC<ButtonProps> = ({
    loading,
    disabled,
    children,
    variant,
    ...props
}) => (variant === 'ghost' ? (
    <ChakraButton
        gap="1rem"
        disabled={disabled || loading}
        cursor="pointer"
        background="transparent"
        shadow="none"
        {...props}
    >
        {loading ? (
            <>
                <AbsoluteCenter display="inline-flex">
                    <Spinner size="inherit" color="inherit" />
                </AbsoluteCenter>
                <Span opacity={0}>{children}</Span>
            </>
        ) : (
            children
        )}
    </ChakraButton>
) : (
    <ChakraButton
        gap="1rem"
        disabled={disabled || loading}
        cursor="pointer"
        {...props}
    >
        {loading ? (
            <>
                <AbsoluteCenter display="inline-flex">
                    <Spinner size="inherit" color="inherit" />
                </AbsoluteCenter>
                <Span opacity={0}>{children}</Span>
            </>
        ) : (
            children
        )}
    </ChakraButton>
));
